/* eslint-disable max-len */
function getJobsFromVacancies(vacancies) {
  return vacancies
    .flatMap((item) => {
      return item.properties.vacancies.map(v => ({
        ...v,
        properties: {
          ...v.properties,
          company: { ...item.properties, geometry: item.geometry },
        },
      }));
    })
    .sort((a, b) => {
      const { distanceToHomeAddress: distanceA, NAZKA_NM: nameA } = a.properties.company;
      const { distanceToHomeAddress: distanceB, NAZKA_NM: nameB } = b.properties.company;

      const isANumber = typeof distanceA === 'number' && !Number.isNaN(distanceA);
      const isBNumber = typeof distanceB === 'number' && !Number.isNaN(distanceB);

      if (isANumber && isBNumber) {
        if (distanceA !== distanceB) {
          return distanceA - distanceB;
        }
      } else if (isANumber) {
        return -1;
      } else if (isBNumber) {
        return 1;
      }

      if (nameA && nameB) {
        return nameA.localeCompare(nameB);
      }

      return 0;
    });
}

function getClusterIds(cluster) {
  const ids = cluster?.properties?.clusterFeatureIds.slice(0, -1).split(',') || [];
  return ids.map((i) => {
    const [OIDN, vdabReferentie] = i.split('|');
    return { OIDN, vdabReferentie };
  });
}

export { getJobsFromVacancies, getClusterIds };
